import { render, staticRenderFns } from "./WordCardTeaserConstructor.vue?vue&type=template&id=01594098&scoped=true&"
import script from "./WordCardTeaserConstructor.vue?vue&type=script&lang=js&"
export * from "./WordCardTeaserConstructor.vue?vue&type=script&lang=js&"
import style0 from "./WordCardTeaserConstructor.vue?vue&type=style&index=0&id=01594098&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01594098",
  null
  
)

export default component.exports